<template>
    <div>
        <div class="content__sandbox" v-if="billing_data.is_test_period">
            <img src="//static.liqpay.ua/checkout/220402183319/img/sandbox_left.svg">
            <div class="content__sandbox__border">Тестовый режим</div>
            <img src="//static.liqpay.ua/checkout/220402183319/img/sandbox_right.svg">
        </div>

        <div class="alert border-danger bg-transparent text-secondary fade show billing-alert" role="alert" v-if="show_notif">
            <div class="d-flex align-items-start">
                <div class="alert-icon mr-3">
					<span class="icon-stack icon-stack-md">
						<i class="base-7 icon-stack-3x color-danger-900"></i>
						<i class="fal fa-times icon-stack-1x text-white"></i>
					</span>
                </div>

                <div class="flex-1">
                    <span class="h5 color-danger-900 d-block mb-1" v-html="__t('NEED_PAY')"></span>

                    <div class="bill-main-line">
                        <span class="bill-usd">{{ billing_data.costs.usd_cost }} $</span>
                        <span class="bill-eq">=</span>
                        <strong class="bill-uah">{{ billing_data.costs.uah_cost | toCurrency }} ₴</strong>
                    </div>

                    <div v-if="hasExtraAdd" class="bill-extra-box mt-2">
                        <div class="bill-extra-title">
                            <i class="fal fa-plus-circle mr-1"></i>
                            {{__t('EXTRA_ADD')}}
                        </div>

                        <div
                            v-for="item in currentBillExtraList"
                            :key="item.id"
                            class="bill-extra-row"
                        >
                            <div class="bill-extra-left">
								<span class="bill-extra-comment">
									{{ item.comment || 'Додаткове нарахування' }}
								</span>
                                <span v-if="item.date" class="bill-extra-date">
									{{ formatDate(item.date) }}
								</span>
                            </div>

                            <div class="bill-extra-right">
								<span v-if="toNumber(item.usd_cost) !== 0" class="bill-extra-usd">
									+{{ moneyUSD(item.usd_cost) }} $
								</span>
                                <span class="bill-extra-uah">
									+{{ moneyUAH(item.uah_cost) }} ₴
								</span>
                            </div>
                        </div>

                        <div class="bill-extra-total">
                            <span>  {{__t('EXTRA_ADD_TOTAL')}}</span>
                            <strong>
                                	<span v-if="toNumber(currentBillExtraAdd.usd_cost) !== 0" class="bill-extra-usd">
									+{{ moneyUSD(currentBillExtraAdd.usd_cost) }} $
								</span>
                                +{{ moneyUAH(currentBillExtraAdd.uah_cost) }} ₴
                            </strong>
                        </div>
                    </div>


                    <div class="mt-2" v-if="!billing_data.is_active_pay">
                        {{ __t("DISABLED_ONLINE_PAY") }}
                    </div>
                </div>

                <div v-if="billing_data.is_active_pay" class="billing-actions">
                    <button
                        type="button"
                        class="btn btn-lg btn-outline-success waves-effect waves-themed mb-2"
                        v-for="bill in bills_pay"
                        :key="bill.bill_id"
                        v-on:click.prevent="go_pay(bill)"
                    >
                        <span class="fal fa-download mr-1"></span>
                        {{ bill.date }}
                    </button>
                </div>

                <choose_payment></choose_payment>
            </div>
        </div>
    </div>
</template>

<script>
import choose_payment from "./choose_payment";

export default {
    name: "notif",
    components: {
        choose_payment
    },
    data() {
        return {
            is_load: false,
            billing_data: {
                pay_url: "",
                need_pay: false,
                is_active_pay: false,
                is_test_period: false,
                costs: {
                    uah_cost: 0,
                    usd_cost: 0,
                    extra_add: {
                        uah_cost: 0,
                        usd_cost: 0,
                    }
                }
            },
        }
    },

    created() {
        this.load_billing();
    },

    methods: {
        async go_pay(bill) {
            EventBus.$emit("show_pay", parseInt(bill.bill_id));
        },

        async load_billing() {
            this.is_load = true;
            await api.get('/internal/v1/billing').then(({data}) => {
                this.is_load = false;
                this.billing_data = data.data;
            }).catch(() => {
                this.is_load = false;
            });
        },

        toNumber(v) {
            const n = Number(v);
            return Number.isFinite(n) ? n : 0;
        },

        moneyUAH(v) {
            return this.formatNumber(this.toNumber(v), 2);
        },

        moneyUSD(v) {
            return this.formatNumber(this.toNumber(v), 2);
        },

        formatNumber(value, decimals) {
            const fixed = this.toNumber(value).toFixed(decimals);
            const [intPart, fracPart] = fixed.split(".");
            const withSpaces = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return fracPart !== undefined ? `${withSpaces}.${fracPart}` : withSpaces;
        },

        formatDate(value) {
            if (!value) {
                return '';
            }

            const d = new Date(value);
            if (isNaN(d.getTime())) {
                return '';
            }

            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();

            return `${day}.${month}.${year}`;
        },
    },

    computed: {
        show_notif() {
            return this.billing_data.need_pay;
        },

        all_bills() {
            if (this.billing_data.hasOwnProperty('bills')) {
                return this.billing_data.bills;
            }

            return [];
        },

        bills_pay() {
            try {
                return this.all_bills.filter(item => item.status === 'invoice');
            } catch (e) {
            }

            return [];
        },

        currentInvoiceBill() {
            return this.bills_pay.length ? this.bills_pay[0] : null;
        },

        currentBillExtraList() {
            if (!this.currentInvoiceBill || !Array.isArray(this.currentInvoiceBill.extra_bill)) {
                return [];
            }

            return this.currentInvoiceBill.extra_bill;
        },

        currentBillExtraAdd() {
            if (this.currentInvoiceBill && this.currentInvoiceBill.extra_add) {
                return this.currentInvoiceBill.extra_add;
            }

            return {
                uah_cost: 0,
                usd_cost: 0,
            };
        },

        hasExtraAdd() {
            return this.toNumber(this.currentBillExtraAdd.uah_cost) !== 0 || this.currentBillExtraList.length > 0;
        },

        totalToPay() {
            return this.toNumber(this.billing_data?.costs?.uah_cost) + this.toNumber(this.currentBillExtraAdd.uah_cost);
        },
    }
}
</script>

<style scoped>
.content__sandbox {
    border-top: 2px solid #927ee7;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: fixed;
    width: 100%;
    z-index: 9000;
    top: 0;
    left: 0;
}

.content__sandbox__border {
    font-size: 13px;
    color: #fff;
    padding: 2px;
    background: #927ee7;
}

.billing-alert {
    border-width: 1px;
    border-style: solid;
    border-radius: 6px;
}

.bill-main-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 15px;
}

.bill-usd {
    color: #6c757d;
}

.bill-eq {
    opacity: 0.7;
}

.bill-uah {
    font-size: 16px;
    color: #343a40;
}

.bill-extra-box {
    background: rgba(220, 53, 69, 0.04);
    border: 1px solid rgba(220, 53, 69, 0.15);
    border-radius: 8px;
    padding: 10px 12px;
    max-width: 620px;
}

.bill-extra-title {
    font-weight: 600;
    color: #b02a37;
    margin-bottom: 8px;
}

.bill-extra-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 6px 0;
    border-top: 1px dashed rgba(0, 0, 0, 0.08);
}

.bill-extra-row:first-of-type {
    border-top: 0;
    padding-top: 0;
}

.bill-extra-left {
    display: flex;
    flex-direction: column;
}

.bill-extra-comment {
    font-size: 14px;
    color: #343a40;
}

.bill-extra-date {
    font-size: 12px;
    color: #6c757d;
    margin-top: 2px;
}

.bill-extra-right {
    display: flex;
    align-items: center;
    gap: 10px;
    white-space: nowrap;
}

.bill-extra-usd {
    font-size: 13px;
    color: #6c757d;
}

.bill-extra-uah {
    font-weight: 600;
    color: #dc3545;
}

.bill-extra-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    font-size: 14px;
}

.bill-total-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid rgba(40, 167, 69, 0.2);
    border-radius: 8px;
    padding: 8px 12px;
}

.bill-total-label {
    color: #495057;
}

.bill-total-value {
    color: #198754;
    font-size: 16px;
}

.billing-actions {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
}
</style>
